export class CategoryConfiguration {
    categoryName: string;

    static serialize(c): any[] {
        const result: any = {
            categoryName: c.categoryName,
        };
        return result;
    }
}